export const b64_encode = (string) => {
	return window.btoa(unescape(encodeURIComponent(string)));
};

export const b64_decode = (string) => {
	return decodeURIComponent(escape(window.atob(string)));
};
